<div class="position-relative overflow-hidden min-vh-100 d-flex align-items-center justify-content-center">
    <div class="d-flex align-items-center justify-content-center w-100">
        <div class="row justify-content-center w-100">
            <div class="col-lg-4">
                <div class="text-center">
                    <!--
                    <img src="../assets/images/backgrounds/maintenance.svg" alt="spike-img" class="img-fluid" width="500">
                    -->
                    <h1 class="fw-semibold my-6 fs-9">You're out!</h1>
                    <h4 class="fw-semibold mb-6">Successfully logged out.</h4>
                    <p class="text-dark fs-4 mb-7">But hey… why so soon? 👀<br />
                        We’ll keep everything warm and ready for when you come back.</p>
                    <p class="text-dark fs-4 mb-7">See you again soon.</p>
                    <a class="btn btn-primary rounded-pill" href="/login" role="button">Back To Login</a>
                </div>
            </div>
        </div>
    </div>
</div>
